import * as React from 'react';
export function ConditionalRenderer(props) {
  var condition = typeof props.if === 'function' ? props.if() : props.if;

  if (condition) {
    return /*#__PURE__*/React.createElement(React.Fragment, null, props.then || props.children);
  }

  return /*#__PURE__*/React.createElement(React.Fragment, null, props.else || null);
}